import { Badge } from '@/components/ui/badge'
import { Typography } from '@/components/ui/typography'
import { Check } from 'lucide-react'
import { useId } from 'react'

// One numbered step in the open and close till workflows, in the order staff work the drawer.
export function CashDrawerWorkflowStep({ number, title, description, done = false, children }) {
  const titleId = useId()

  return (
    <section aria-labelledby={titleId} className="space-y-4">
      <div className="flex min-w-0 items-start gap-3">
        <Badge variant={done ? 'success' : 'brand'} size="statusIcon" aria-hidden="true">
          {done ? <Check className="size-3.5" /> : number}
        </Badge>
        <div className="min-w-0 space-y-1">
          <Typography id={titleId} variant="labelStrong" className="block">
            {title}
          </Typography>
          {description ? (
            <Typography variant="supporting" className="block">
              {description}
            </Typography>
          ) : null}
        </div>
      </div>
      <div className="min-w-0 space-y-4 @sm:pl-9">{children}</div>
    </section>
  )
}
